export default "__VITE_ASSET__Cy0cW6aw__"